<template>
  <content-page>
    <div class="row">
      <div class="col-lg-12">
        <h1>OP'N handelsbetingelser</h1>
        <p class="lead">
            Nedenfor kan du finde de generelle vilkår for brug af OP'N ydelsen. Vi opfordrer til, at du læser dem grundigt igennem, inden du gør brug af ydelsen.
        </p>
        <p>
            <strong>Emner:</strong>
            <br>
            <ol>
                <li>Anvendelse</li>
                <li>Ydelsen</li>
                <li>Priser og betaling</li>
                <li>Levering</li>
                <li>Ansvar</li>
                <li>Fortrydelse</li>
                <li>Databehandling</li>
                <li>Kontakt</li>
                <li>Lov og værneting</li>
            </ol>
        </p>
        <h2>Anvendelse</h2>
        <p>
            Disse handelsbetingelser (herefter kaldet ”Betingelserne”) gælder for alle ydelser der leveres på app.opnx.dk (herefter kaldet ”Servicen”) af OP'N og Generaxion A/S herefter kaldet ”Virksomheden”), som brugere heraf (herefter kaldet ”Brugere”) måtte anvende.
        </p>
        <h2>Ydelsen</h2>
        <p>
            De ydelser/integration, der bliver leveret fra Servicen er afhængige af Brugerens input eller handlinger, hvorfor eventuelle fejl i Brugerens input eller valg ikke er Virksomhedens ansvar. Ligeledes hentes data fra eksterne services ind i Servicen med det formål at Brugeren selv kan tilkoble og frakoble datapunkter. Det er ikke Virksomhedens ansvar at sikre lovligheden af den data der fremhæves for Brugeren. Brugeren kan altid henvende sig til Virksomheden ved tvivlsspørgsmål ift. brug af Servicen.
        </p>
        <p>Brug af Servicen medfølger ikke arbejde af Generaxion A/S medarbejdere ift. optimering af online markedsføringsprodukter eller webudvikling.</p>
        <p>Servicen har alene til formål at tilbyde Brugeren et overblik over udvalgte datapunkter.</p>
        <h2>Priser og betaling</h2>
        <p>
            Servicen tilbydes som freemium, som er gratis at tilgå og anvende. Herudover tilbydes servicen i en udvidet model mod betaling for kr. 199 om måneden. Fakturering heraf følger Virksomhedens generelle leveringsbetingelser.
        </p>
        <h2>Levering</h2>
        <p>
            Når Brugeren har oprettet en konto, har Brugeren adgang til Servicen via login på app.opnx.dk. Adgang til Servicen ophører hvis Brugeren sletter sin konto.
        </p>
        <h2>Ansvar</h2>
        <p>
            Virksomheden er i intet tilfælde ansvarlige for Brugerens viste data, lovligheden af forbundne datapunkter, de informationer der vises for Brugeren eller hvad Brugeren anvender viste datainformationer til. Virksomheden fraskriver sig desuden ethvert ansvar i situationer, der må betegnes som force majeure lignende, fx strejke, pandemi, brand, naturkatastrofer, afbrydelser og/eller svigt i energiforsyning og/eller kommunikationssystemer.
        </p>
        <p>Brugeren er alene ansvarlig for informationerne på deres profil er korrekte og at de valgte integrationer er forbundet til datapunkter som Brugeren har lovlig adgang til.</p>
        <p>Virksomheden fraskriver sig ethvert ansvar for hvad Brugeren vælger at bruge Servicen til.</p>
        <h2>Fortrydelse</h2>
        <p>Brugeren kan selv eller ved kontakt til Virksomheden få slettet sin adgang til Servicen. Ved betalt adgang gælder Generaxion A/S normale betalingsbetingelser.</p>
        <h2>Databehandling</h2>
        <p>
            Her følges OP'Ns <router-link :to="{name: 'privacy-policy'}">privatlivs- og cookiepolitik.</router-link>
        </p>
        <h2>Kontakt</h2>
        <p>
            <strong>Servicen OP'N udbydes og drives af:</strong>
            <br>
            <br>
            Generaxion
            <br>
            Sommervej 23A
            <br>
            DK-8210 Aarhus V
            <br>
            <br>
            Cvr nr: 31 18 98 10
            <br>
            Tlfnr : 70 23 10 23
            <br>
            E-mail: info@generaxion.dk
            <br>
            Etableringsår: 2008
        </p>
        <h2>Lov og værneting</h2>
        <p>Enhver tvist som måtte udspringe af Brugerens anvendelse af Servicen skal anlægges ved Byretten i Aarhus. Tvisten afgøres efter dansk ret.  </p>
      </div>
    </div>
  </content-page>
</template>

<script>
import ContentPage from "@/components/ContentPage";

export default {
  components: {
    ContentPage,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/TermsOfService.vue